'use client'

import { motion } from 'framer-motion'

export default function SamanthaOrb() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <motion.div
        className="relative h-[420px] w-[420px] rounded-full blur-3xl"
        animate={{
          scale: [1, 1.08, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
        style={{
          background:
            'radial-gradient(circle at 30% 30%, rgba(0,255,255,0.8), transparent 45%), radial-gradient(circle at 70% 70%, rgba(140,0,255,0.9), transparent 50%)',
        }}
      >
        {/* núcleo interno */}
        <motion.div
          className="absolute inset-0 rounded-full blur-2xl"
          animate={{
            opacity: [0.6, 1, 0.6],
          }}
          transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          style={{
            background:
              'radial-gradient(circle, rgba(140,0,255,0.6), rgba(0,255,255,0.4), transparent 70%)',
          }}
        />
      </motion.div>
      <motion.div
        className="absolute h-[500px] w-[500px] rounded-full border border-cyan-400/20"
        animate={{
            scale: [1, 1.4],
            opacity: [0.5, 0],
        }}
        transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeOut',
        }}
        />
    </div>
  )
}